/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Assignee_AutomaticInputs */

const en_task_field_assignee_automatic = /** @type {(inputs: Task_Field_Assignee_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic assignment`)
};

const pt_br2_task_field_assignee_automatic = /** @type {(inputs: Task_Field_Assignee_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuição automática`)
};

/**
* | output |
* | --- |
* | "Automatic assignment" |
*
* @param {Task_Field_Assignee_AutomaticInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_assignee_automatic = /** @type {((inputs?: Task_Field_Assignee_AutomaticInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Assignee_AutomaticInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_assignee_automatic(inputs)
	return pt_br2_task_field_assignee_automatic(inputs)
});